import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Order } from 'src/graphql/report-service/generated/operations';
import Button from '@mui/material/Button';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { grey } from '@mui/material/colors';

import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import OrderRowDetails from './details';

const OrderTableRow = function ({ order }: { order: Order }) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const date = order.date ? dayjs(order.date).format('YYYY-MM-DD HH:mm') : '';

  return (
    <>
      <TableRow hover data-test-id="order-stats-row">
        <TableCell>{order.orderNumber}</TableCell>
        <TableCell>{date}</TableCell>
        <TableCell>{t(`ingestion.${order.ingestion}`)}</TableCell>
        <TableCell>{order.mobile}</TableCell>
        <TableCell>{t(`paymentType.${order.paymentType}`)}</TableCell>
        <TableCell align="right">
          <Typography>
            {t('formatters.number', { val: order.amount, minimumFractionDigits: 0 })}
          </Typography>
        </TableCell>
        <TableCell align="right">
          <Typography>
            {t('formatters.number', { val: order.tip, minimumFractionDigits: 0 })}
          </Typography>
        </TableCell>
        <TableCell align="right">{order.table}</TableCell>
        <TableCell align="right">
          <Button
            size="small"
            variant="text"
            data-test-id="order-stats-row-cta"
            onClick={() => setOpen(!open)}
            endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          >
            Orderinfo
          </Button>
        </TableCell>
      </TableRow>
      <TableRow sx={{ backgroundColor: grey[50] }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          <OrderRowDetails open={open} order={order} />
        </TableCell>
      </TableRow>
    </>
  );
};

export default OrderTableRow;
